import classes from "./Article.module.css";
import { Fragment, useContext, useEffect } from "react";
import Card from "../UI/Card";

import GermanyContext from "../../store/germany-context";

import act1 from "../../assets/germanyArticle/1.png";
import act2 from "../../assets/germanyArticle/2.png";
import act3 from "../../assets/germanyArticle/3.png";
import act4 from "../../assets/germanyArticle/4.png";
import act5 from "../../assets/germanyArticle/5.png";
import act6 from "../../assets/germanyArticle/6.png";
import act7 from "../../assets/germanyArticle/7.png";
import act8 from "../../assets/germanyArticle/8.png";
import act9 from "../../assets/germanyArticle/9.png";

import act_pdf from "../../assets/germanyArticle/Ewaluacja_Peter.pdf";

import videoMeet from "../../assets/germanyArticle/germany.MOV";
import videoChurchil from "../../assets/germanyArticle/Zusammengesetzter.mp4";

const GermanyArticle = (props) => {
  const gerCtx = useContext(GermanyContext);

  useEffect(() => {
    document
      .getElementById(props.id)
      .scrollIntoView({ behavior: "smooth", block: "start" });
  }, [props.id]);

  return (
    <Fragment>
      <p className="main" id="act"></p>
      <Card>
        <div>
          <h1 className={classes.header}>School Project Activities</h1>
          <h2 className={classes.header}>{gerCtx.activities[0]}</h2>
          <p className={classes.text}>{gerCtx.activities[1]}</p>
          <p className={classes.text}>{gerCtx.activities[2]}</p>
          <p className={classes.text}>{gerCtx.activities[3]}</p>
          <p className={classes.text}>{gerCtx.activities[4]}</p>
          <div className={classes.center}>
            <img className={classes.single} src={act1} alt="" />
          </div>

          <h2 className={classes.header}>Lise-Meitner Grammar School</h2>
          <div className={classes.center}>
            <video className={classes.video} controls>
              <source src={videoMeet} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className={classes.center}>
            <h1 className={classes.header}>
              Evaluation Questionaire Babica 2020
            </h1>
            <div className={classes.frame}>
              <iframe
                title={"iframe"}
                src={act_pdf}
                className={classes.iframe}
                overflow="visible"
                width="100%"
                height="100%"
              >
                <div>No PDF viewer available</div>
              </iframe>
            </div>
          </div>
        </div>
      </Card>
      <p className="main" id="meet"></p>
      <Card>
        <div>
          <h1 className={classes.header}>Project Meeting</h1>
          <h2 className={classes.header}>
            Proud to be European – the project week in Germany
          </h2>
          <p className={classes.text}>{gerCtx.meeting[0]}</p>
          <p className={classes.text}>{gerCtx.meeting[1]}</p>
          <p className={classes.text}>{gerCtx.meeting[2]}</p>
          <p className={classes.text}>{gerCtx.meeting[3]}</p>
          <p className={classes.text}>{gerCtx.meeting[4]}</p>
          <p className={classes.text}>{gerCtx.meeting[5]}</p>
          <h2 className={classes.header}>Proud to be European - Video</h2>
          <div className={classes.center}>
            <video className={classes.video} controls>
              <source src={videoChurchil} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <h2 className={classes.header}>{gerCtx.activities[5]}</h2>
          <div className={`${classes.images} ${classes.center}`}>
            <article>
              <img className={classes.image} src={act2} alt="" />
            </article>
            <article>
              <img className={classes.image} src={act3} alt="" />
            </article>
          </div>
          <div className={`${classes.images} ${classes.center}`}>
            <article>
              <img className={classes.image} src={act4} alt="" />
            </article>
            <article>
              <img className={classes.image} src={act5} alt="" />
            </article>
          </div>
          <h2 className={classes.header}>
            Nasz pierwszy dzień w niemieckiej szkole / Our first day at german
            school
          </h2>
          <div className={`${classes.images} ${classes.center}`}>
            <article>
              <img className={classes.image} src={act6} alt="" />
            </article>
            <article>
              <img className={classes.image} src={act7} alt="" />
            </article>
          </div>
          <div className={`${classes.images} ${classes.center}`}>
            <article>
              <img className={classes.image} src={act8} alt="" />
            </article>
            <article>
              <img className={classes.image} src={act9} alt="" />
            </article>
          </div>
        </div>
      </Card>
    </Fragment>
  );
};

export default GermanyArticle;
